import WarningIcon from '@mui/icons-material/WarningAmberRounded'

import { useGetQuoteConstraints, type Quote } from '../../../modules/quotes'
import Tooltip from '../../Tooltip'
import { useQuoteContext } from '../QuoteComponent.context'
import { ConstraintIcon } from './ConstraintIcon'
import { useGetConstraintDescription } from './useGetConstraintDescription'

type ConstraintsProps = {
  quote: Quote
  jobIndex?: number
  compact?: boolean
}

const Constraints: React.FC<ConstraintsProps> = ({
  quote,
  jobIndex,
  compact = false,
}) => {
  const { ignoreConstraints = false } = useQuoteContext()
  const constraints = useGetQuoteConstraints()(quote, jobIndex)
  const getConstraintDescription = useGetConstraintDescription()
  const multiJobs = quote.jobs.length > 1
  const jobQuote = (compact && multiJobs) ? undefined : quote.jobs[jobIndex ?? 0]

  const nbConstraints = constraints?.length ?? 0
  if (!constraints || nbConstraints === 0 || ignoreConstraints) {
    return null
  }

  if (compact) {
    return (
      <Tooltip
        tooltip={(
          <ul
            className={nbConstraints > 1 ? 'list-disc pl-2' : ''}
          >
            { constraints.map((constraint) => (
              <li key={constraint}>
                { getConstraintDescription(constraint, { jobQuote }) }
              </li>
            )) }
          </ul>
        )}
        className="bg-yellow-700 text-white"
      >
        <div className="flex items-center gap-1 rounded bg-orange-100 px-3 py-1 text-sm text-yellow-700">
          { nbConstraints > 1
            ? (
              <>
                { nbConstraints } <WarningIcon className="!text-[22px]" />
              </>
              )
            : (
              <ConstraintIcon constraint={constraints[0]} />
              ) }

        </div>
      </Tooltip>
    )
  }

  return (
    <div className="mb-3 flex flex-col gap-2 2xl:mb-4">
      { constraints?.map(constraint => {
        return (
          <div key={constraint} className="items-center gap-1 rounded bg-orange-100 px-3 py-2 text-sm text-yellow-700 lg:flex">
            <ConstraintIcon constraint={constraint} />
            { ' ' }
            { getConstraintDescription(constraint, { jobQuote }) }
          </div>
        )
      }) }
    </div>
  )
}

export default Constraints
